
import Vue from "vue";
import AppCustomTable from "@/components/common/CustomTable.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { printHumanFloat } from "@/utils/pretty-print";

interface IPriceRow {
	id:number;
	name:string;
	excl:string;
	incl:string;
}

export default Vue.extend({
	props: {
		item: {
			type: Object as () => any,
			required: true
		}
	},
	computed: {
		categories():IPriceRow[] {
			let config = DossierConfigService.getSellCategories();
			return config.getActiveCategories().map(c=>{
				return {
					id: c.id,
					name: config.getCategoryName(c.id),
					excl: printHumanFloat(this.item[`SellPrice${c.id}`] || 0, 2),
					incl: printHumanFloat(this.item[`SellPrice${c.id}WithVat`] || 0, 2)
				};
			});
		},
		summary():string {
			let first = this.categories[0];
			if (!first) return "";
			return `${first.name} ${first.incl}`;
		},
		buyPrice():string | null {
			if (typeof this.item.BuyNettoPrice == "number") {
				return printHumanFloat(this.item.BuyNettoPrice, 2);
			}
			let supplier = this.item.MainSupplier;
			if (supplier && supplier.ID && typeof supplier.NettoPrice == "number") {
				return printHumanFloat(supplier.NettoPrice, 2);
			}
			let stock = this.item.Stock;
			if (stock && stock.ID && typeof stock.BuyNettoPrice == "number") {
				return printHumanFloat(stock.BuyNettoPrice, 2);
			}
			return null;
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		item(){
			this.$emit("summary", this.summary);
		}
	},
	components: {
		AppCustomTable
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
